<script>
import { onMount } from 'svelte';
import Route from '../libs/Route.svelte';
import Homepage from './Homepage.svelte';
import SprintList from './SprintList.svelte';
import Sprint from './Sprint.svelte';
import SprintEditor from './SprintEditor.svelte';
import Results from './Results.svelte';
import Globals from './Globals.svelte';
import globals from '../globals';
import * as firebase from '../data/firebase';
import * as sprintData from '../data/sprints';
import * as serverData from '../data/server';
import * as userData from '../data/user';

let globalsInstance;
let y;

Object.keys(firebase).forEach(key => window[key] = firebase[key]);
Object.keys(sprintData).forEach(key => window[key] = sprintData[key]);
Object.keys(serverData).forEach(key => window[key] = serverData[key]);
Object.keys(userData).forEach(key => window[key] = userData[key]);
window.globals = globals;

onMount(() => {
	globals.alert = globalsInstance.alert;
	globals.confirm = globalsInstance.confirm;
	globals.inform = globalsInstance.inform;
	globals.prompt = globalsInstance.prompt;
})
</script>

<section class="app-nav">
	<header class="color-invert">
		<a class="logo" href="/" title="Home">Word sprints</a>
		<div class="built" style="opacity:{1 - Math.max(0, Math.min(1, y/13))}">
			<span class="brought"><span class="longer"></span>by</span>
			<a class="dabble-logo" href="https://www.dabblewriter.com/?utm_source=wordsprints&utm_medium=web&utm_campaign=wordsprints_brought">Dabble</a>
		</div>
	</header>
</section>
<div class="built-fixed">
	<span class="brought"><span class="longer"></span>by</span>
	<a class="dabble-logo" href="https://www.dabblewriter.com/?utm_source=wordsprints&utm_medium=web&utm_campaign=wordsprints_brought">Dabble</a>
</div>
<div class="app-content">
	<Route path="/" component={Homepage}/>
	<Route path="/sprints" component={SprintList}/>
	<Route path="/sprints/:sprintId" component={Sprint}/>
	<Route path="/sprint-edit/:sprintId" component={SprintEditor}/>
	<Route path="/results" component={Results}/>
</div>

<svelte:window bind:scrollY={y}/>

<Globals bind:this={globalsInstance}/>

<style>
.app-nav {
	background: var(--white);
	box-shadow: 0 1px 2px rgba(0, 0, 0, .15);
	position: relative;
	z-index: 2;
}
.app-nav header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 56px;
}
.logo {
	display: inline-block;
	overflow: hidden;
	text-indent: -400px;
	width: 208px;
	height: 40px;
	background: url(/logo.png) no-repeat left bottom;
	background-size: contain;
}
.built {
	display: flex;
	align-items: flex-start;
}
.built-fixed {
	position: fixed;
	right: calc(50% - 530px);
	top: 13px;
	display: flex;
	align-items: flex-start;
}
.brought {
	flex: 1;
	text-align: right;
	margin: 16px 8px 0 10px;
	font-size: var(--font-size-050);
	color: var(--warm-grey-600);
}
.dabble-logo {
	display: inline-block;
	overflow: hidden;
	text-indent: -400px;
	width: 99px;
	height: 30px;
	background: url(/dabble-logo.png) no-repeat left bottom;
	background-size: contain;
}
@media (max-width: 1044px) {
  .built {
	right: 8px;
  }
}
@media (max-width: 640px) {
	.longer {
		display: none;
	}
	.dabble-logo {
		width: 90px;
	}
}
@media print {
  .app-nav {
    display: none;
  }
}
</style>